import { AnimatePresence, motion } from 'framer-motion';
import useDndStore from '../../stores/dndStore';
import { Item } from '../ItemWrapper';
import React, { useEffect, useRef, useState } from 'react';
import { CollapsedSpace, Header } from '../Groups';
import { Box } from '@chakra-ui/layout';
import { Resizable } from 're-resizable';
import { useColorModeValue, Text, Flex } from '@chakra-ui/react';
import usePersistStore from '../../../sharedCode/stores/persistStore';
import { useWillChange } from 'framer-motion';
import ActiveTabGroup, {
    GroupIcon
} from '../../../platformFiles/extensionSpecific/ActiveTabGroup';
import EditableTitle from '../EditableTitle';
import { folderColorProvider } from '../../../sharedCode/Utils/colorProvider';

const DragOverlayItem = ({}) => {
    const activeItem = useDndStore((state) => state.activeItem);

    useEffect(() => {
        if (activeItem?.dragType === 'tab') {
            let dragItemsConfirmed = {};
            useDndStore.getState().dragIds.forEach((id) => {
                dragItemsConfirmed[id] = true;
            });
            useDndStore.setState({
                globalIsDragging: true,
                dragItemsConfirmed: dragItemsConfirmed
            });
        } else if (activeItem?.dragType === 'dragGroup') {
            useDndStore.setState({ globalGroupIsDragging: true });
        }
    }, []);
    const dragEndAnimation = useDndStore((state) => state.dragEndAnimation);
    const setAnimationComplete = useDndStore(
        (state) => state.setAnimationComplete
    );
    const dragItems = useDndStore((state) => state.dragItems);
    // let dragItemsWithoutActive = dragItems.filter(
    //     (item) => item.id !== activeItem.id
    // );

    const handleAnimationComplete = () => {
        // console.log('handle animation complete.');
        setAnimationComplete();
    };
    let showNumberOfDraggedItems = dragItems.length;
    // const dragItemDisplacement = useDndStore(
    //     (state) => state.dragItemDisplacement
    // );

    if (!activeItem) {
        return null;
    }

    return (
        <div>
            {activeItem.dragType === 'tab' && !activeItem.isActiveGroup ? (
                <TabOverlayItem
                    item={activeItem}
                    dragEndAnimation={dragEndAnimation[activeItem.id]}
                    handleAnimationComplete={handleAnimationComplete}
                    showNumberOfDraggedItems={showNumberOfDraggedItems}
                    initialAnimation={false}
                />
            ) : activeItem.dragType === 'tab' ? (
                <ActiveTabGroupOverlay
                    item={activeItem}
                    dragEndAnimation={dragEndAnimation[activeItem.id]}
                    handleAnimationComplete={handleAnimationComplete}
                    showNumberOfDraggedItems={activeItem.numberOfTabsInside}
                    initialAnimation={false}
                />
            ) : activeItem.dragType === 'dragGroup' ? (
                <GroupOverlayItem
                    item={activeItem}
                    dragEndAnimation={dragEndAnimation[activeItem.id]}
                    handleAnimationComplete={handleAnimationComplete}
                    initialAnimation={false}
                />
            ) : null}
            {/* {activeItem.dragType === 'tab'
                ? dragItemsWithoutActive.map((selectedItem, index) => {
                      if (dragEndAnimation[activeItem.id]) {
                          return (
                              <TabOverlayItem
                                  item={{
                                      ...selectedItem,
                                      width: activeItem.width
                                  }}
                                  dragEndAnimation={
                                      dragEndAnimation[selectedItem.id]
                                  }
                                  handleAnimationComplete={() => void 0}
                                  showNumberOfDraggedItems={false}
                                  initialAnimation={true}
                              />
                          );
                      } else {
                          return null;
                      }
                  })
                : null} */}
        </div>
    );
};

const TabOverlayItem = ({
    item,
    dragEndAnimation,
    handleAnimationComplete,
    showNumberOfDraggedItems,
    initialAnimation
}) => {
    /* useEffect(() => {
        return () => {
            const globalIsDragging = useDndStore.getState().globalIsDragging;
            console.log('unmount TabOverlayItem', globalIsDragging);

            if (!globalIsDragging) {
                handleAnimationComplete();
            }
        };
    }, []); */
    if (item.isActiveTab) {
        item.width = (usePersistStore.getState().sidebarWidth - 42) * 1.0225;
    }

    return (
        <div
            // animate={{
            //     scale: dragEndAnimation ? 1 : 1.0225,
            //     x: dragEndAnimation ? dragEndAnimation.x : 0,
            //     y: dragEndAnimation ? dragEndAnimation.y - 2 : 0,
            //     opacity: dragEndAnimation ? 1 : 0.999
            // }}
            // onAnimationComplete={() =>
            //     onAnimationCompleteMiddle(
            //         dragEndAnimation,
            //         handleAnimationComplete
            //     )
            // }
            //initial={{ scale: 1.0225 }}
            // transition={{ duration: 0.2 }}
            style={{
                transform: 'scale(1.0225)',
                width: item.width
                //opacity: 0.9,
                //position: 'absolute'
                //filter: draggingDropShadow,
                // display: 'flex',
                // flexDirection: 'column',
                // textAlign: 'center',
                // alignItems: 'center',
                //cursor: 'grabbing'
                //boxShadow: 'inset 0px 0px 0px 2px #44E18C',
                //filter: draggingDropShadow
                // overflowX: 'hidden'
            }}
        >
            <Item
                data={{ ...item, id: item.id + 'dragOverlay' }}
                overlayItem={true}
                isActiveTab={item.isActiveTab}
            />
            {!!showNumberOfDraggedItems && showNumberOfDraggedItems > 1 && (
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    exit={{ scale: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    style={{
                        position: 'absolute',
                        top: -10,
                        right: -10,
                        width: '30px',
                        height: '30px',
                        borderRadius: '8px',
                        backgroundColor: 'var(--chakra-colors-groupBg)',
                        border: '2px solid #44E18C',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}
                >
                    <Text fontWeight="600" fontSize="16px" m="auto">
                        {showNumberOfDraggedItems}
                    </Text>
                </motion.div>
            )}
        </div>
    );
};

const ActiveTabGroupOverlay = ({
    item,
    dragEndAnimation,
    handleAnimationComplete,
    showNumberOfDraggedItems,
    initialAnimation
}) => {
    // useEffect(() => {
    //     return () => {
    //         const globalIsDragging = useDndStore.getState().globalIsDragging;
    //         if (!globalIsDragging) {
    //             handleAnimationComplete();
    //         }
    //     };
    // }, []);
    if (item.isActiveTab) {
        item.width = (usePersistStore.getState().sidebarWidth - 42) * 1.0225;
    }
    const draggingDropShadow = useColorModeValue(
        'drop-shadow(0 12px 12px rgba(152,169,185,0.64))',
        'drop-shadow(0 12px 12px rgba(0,0,0,0.84))'
    );

    return (
        <AnimatePresence initial={initialAnimation}>
            <motion.div
                animate={{
                    scale: dragEndAnimation ? 1 : 1.0225,
                    x: dragEndAnimation ? dragEndAnimation.x : 0,
                    y: dragEndAnimation ? dragEndAnimation.y - 2 : 0,
                    opacity: dragEndAnimation ? 1 : 0.999
                }}
                onAnimationComplete={() =>
                    onAnimationCompleteMiddle(
                        dragEndAnimation,
                        handleAnimationComplete
                    )
                }
                initial={{ scale: 1.0225 }}
                transition={{ duration: 0.2 }}
                style={{
                    width: item.width,
                    position: 'absolute',
                    filter: draggingDropShadow,
                    // display: 'flex',
                    // flexDirection: 'column',
                    // textAlign: 'center',
                    // alignItems: 'center',
                    cursor: 'grabbing'
                    //boxShadow: 'inset 0px 0px 0px 2px #44E18C',
                    //filter: draggingDropShadow
                    // overflowX: 'hidden'
                }}
            >
                {/* <ActiveTabGroup
                    index={0}
                    title={item.title}
                    color={item.color}
                    emoji={item.emoji}
                    tabsInside={[]}
                    id={'activeGroupOverlay'}
                /> */}
                <Box
                    id={'activeGroupDragOverlay'}
                    // ref={setNodeRef}
                    //w={hoverSide ? 'auto' : '52px'}
                    minW="52px"
                    role="group"
                    pos="relative"
                    bg={folderColorProvider(item.color, 0.24, -10)}
                    // onMouseEnter={hover.on}
                    // onMouseOver={hover.on}
                    // onMouseLeave={hover.off}
                    // bg={isDragging || isOpen ? bgColor : 'transparent'}
                    p="2px 0px 0px"
                    //border="1px solid"
                    //borderColor="#00000010"
                    alignItems="center"
                    my="2px"
                    rounded="10px"
                    cursor={'grab'}
                    _active={{ cursor: 'grabbing' }}
                    // _hover={
                    //     isSelected || isDragging || isOpen
                    //         ? undefined
                    //         : {
                    //               boxShadow: loading ? '' : hoverShadow,
                    //               cursor: 'grab',
                    //               zIndex: 300,
                    //               bg: bgColor
                    //           }
                    // }
                    // onClick={(e) => handleClick(e)}
                    transition="0.17s cubic-bezier(0.22,0.61,0.36,1)"
                    boxShadow={
                        '0px 0px 0px 1px #44e18c, inset 0px 0px 0px 1px #44e18c'
                    }
                >
                    <Flex alignItems="center" p="0px 10px 2px">
                        <GroupIcon
                            icon={item.emoji}
                            color={item.color}
                            currentTitle={item.title}
                            windowId={item.windowId}
                            id={'activeGroupDragOverlay'}
                            setKeepInfoPopoverClosed={true}
                        />

                        <Flex
                            // opacity={hoverSide ? 1 : 0}
                            transition={'0.18s ease'}
                        >
                            <EditableTitle
                                ml={'16px'}
                                title={item.title}
                                size={'sm'}
                                onSubmit={() => {}}
                            />
                        </Flex>
                        {/* <Button
                            bg="transparent"
                            size="sm"
                            ml="auto"
                            //ml={isHover ? '2px' : 'auto'}
                            p="0"
                            rounded="8px"
                            _hover={{ bg: buttonHoverBg }}
                            _active={{ bg: buttonActiveBg }}
                            transition={'0.1s'}
                            onClick={toggleOpen}
                            //isDisabled={disableOpen}
                        > */}
                        <Text
                            ml={'auto'}
                            fontSize="13px"
                            fontWeight="500"
                            maxWidth="16px"
                            //letterSpacing="0.64px"
                            opacity={0.5}
                        >
                            {showNumberOfDraggedItems}
                        </Text>
                        {/* </Button> */}
                    </Flex>
                </Box>
            </motion.div>
        </AnimatePresence>
    );
};

const GroupOverlayItem = ({
    item,
    dragEndAnimation,
    handleAnimationComplete,
    initialAnimation
}) => {
    /* const draggingDropShadowCollapsed = useColorModeValue(
        'drop-shadow(0 16px 8px rgba(152,169,185,0.64))',
        'drop-shadow(0 16px 8px rgba(0,0,0,0.84))'
    ); */
    const draggingDropShadow = useColorModeValue(
        'drop-shadow(0 16px 12px rgba(5, 9, 13, 0.28))',
        'drop-shadow(0 16px 12px rgba(0,0,0,0.84))'
    );

    if (item.collapsedGroup) {
        return (
            <motion.div
                animate={{
                    scale: dragEndAnimation ? 1 : 1,
                    x: dragEndAnimation ? dragEndAnimation.x : 0,
                    y: dragEndAnimation ? dragEndAnimation.y : 0,
                    opacity: dragEndAnimation ? 1 : 0.999
                }}
                onAnimationComplete={() =>
                    onAnimationCompleteMiddle(
                        dragEndAnimation,
                        handleAnimationComplete
                    )
                }
                initial={{ scale: 1 }}
                transition={{ duration: 0.2 }}
                style={{
                    height: 'calc(100vh - 105px)',
                    position: 'absolute',
                    display: 'flex',
                    flexDirection: 'column',
                    textAlign: 'center',
                    alignItems: 'center',
                    cursor: 'grabbing',
                    filter: draggingDropShadow
                }}
            >
                <CollapsedSpace group={item} index={0} overlayItem={true} />
            </motion.div>
        );
    }
    return (
        <AnimatePresence initial={initialAnimation}>
            <motion.div
                animate={{
                    scale: dragEndAnimation ? 1 : 1,
                    x: dragEndAnimation ? dragEndAnimation.x : 0,
                    y: dragEndAnimation ? dragEndAnimation.y : 0,
                    opacity: dragEndAnimation ? 1 : 0.999
                }}
                onAnimationComplete={() =>
                    onAnimationCompleteMiddle(
                        dragEndAnimation,
                        handleAnimationComplete
                    )
                }
                initial={{ scale: 1 }}
                transition={{ duration: 0.2 }}
                style={{
                    position: 'absolute',
                    display: 'flex',
                    flexDirection: 'column',
                    textAlign: 'center',
                    alignItems: 'center',
                    cursor: 'grabbing',
                    filter: draggingDropShadow
                }}
            >
                <Box
                    // ref={groupRef}
                    rounded="13px"
                    boxShadow={'inset 0 0 0 2px #44e18c'}
                    h={item.groupHeight ? item.groupHeight : '100%'}
                    mr="16px"
                    bg="groupBg"
                    my="auto"
                    display="flex"
                    flexDir={'column'}
                    alignItems={'left'}
                    alignContent={'start'}
                    textAlign={'left'}
                    minWidth={'240px'}
                    width={item.width}
                >
                    <Header
                        groupData={item}
                        howManySites={item.tabs?.length}
                        index={0}
                        overlayItem={true}
                        width={item.width}
                        groupHeight={null}
                    />
                    <div
                        style={{
                            height: 'calc(100% - 95px)',
                            overflow: 'hidden',
                            padding: '0 12px 8px'
                        }}
                    >
                        {item.tabs.map((t, i) => (
                            <Item key={i} data={t} groupId={item.id} />
                        ))}
                    </div>
                    {/* </Resizable> */}
                </Box>
            </motion.div>
        </AnimatePresence>
    );
};

export default DragOverlayItem;
const onAnimationCompleteMiddle = (
    dragEndAnimation,
    handleAnimationComplete
) => {
    if (!dragEndAnimation) {
        return;
    }
    handleAnimationComplete();
};
